import Vue from 'vue'
import vuex from 'vuex'
import getters from './getters'
import allType from './modules/getAllType'
import oneType from './modules/getOneType'
import travleBanner from './modules/getTravleBanner'
import travleSec from './modules/travleSec'
import travleList from './modules/getTravleList'
import marketList from './modules/getMarketList'
import changeTravleType from './modules/changeTravleType'
import changeMarketType from './modules/changeMarketType'
import changeUserMarketType from './modules/changeUserMarketType'
import changeEducation from './modules/changeEducation'
import mutualLove from './modules/mutualLove'
import mutualLove1 from './modules/mutualLove1'
import mutualLovenum from './modules/mutualLovenum'
import chosenum from './modules/lovedetil'
import mutinid from './modules/mutinid'
import mutualLoveJS from './modules/mutualLoveJS'
import marketGoodsList from './modules/getMarketGoodsList'
import travleDetail from './modules/getTravleDetail'
import marketDetail from './modules/getMarketDetail'
import travleDetailJ from './modules/getTravleDetailJ'
import travleDetailR from './modules/getTravleDetailR'
import axioslogin from './modules/axioslogin'
import travleDetailRecommend from './modules/getTravleDetailRecommend'
import marketDetailRecommend from './modules/getMarketDetailRecommend'
import travleDetailNav from './modules/getTravleDetailNav'
import nearbyScenic from './modules/getNearbyScenic'
import houseData from './modules/houseData'
import idleData from './modules/idleData'
import logisticsData from './modules/logisticsData'
import navigation from './modules/navagation'
import sameType from './modules/sameType'
import sameCateInfo from './modules/getSameCateInfo'
import wzmallStoreData from './modules/wzmallStoreData'

Vue.use(vuex)

const store = new vuex.Store({
  modules: {
    allType,
    oneType,
    travleBanner,
    travleSec,
    travleList,
    marketList,
    changeTravleType,
    changeMarketType,
    changeUserMarketType,
    changeEducation,
    mutualLove,
    mutualLoveJS,
    mutualLove1,
    mutualLovenum,
    axioslogin,
    chosenum,
    mutinid,
    marketGoodsList,
    travleDetail,
    marketDetail,
    travleDetailRecommend,
    marketDetailRecommend,
    travleDetailNav,
    travleDetailJ,
    travleDetailR,
    nearbyScenic,
    houseData,
    idleData,
    logisticsData,
    navigation,
    sameType,
    sameCateInfo,
    wzmallStoreData
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js